import * as React from 'react';
import * as classNames from 'classnames';
import { observer } from 'mobx-react';
import { toPath } from '../../../../../common/helpers/toPath';

// Styles
const s = require('./UniversalNavigationBar.css');

// Interfaces
interface IUniversalNavigationLink {
    key: string;
    title: string;
    active?: boolean;
    onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
}

// Props
interface IUniversalNavigationBarProps {
    links: IUniversalNavigationLink[];
}

// Component
@observer
export class UniversalNavigationBar extends React.Component<IUniversalNavigationBarProps, {}> {
    render() {
        return (
            <div className={s.links}>
                {this.props.links.map((link, linkIndex) => {
                    return (
                        <a
                            key={link.key}
                            className={classNames({ [s.active]: link.active })}
                            href={`internal/${toPath(link.title)}`}
                            onClick={this.handleLinkClick(linkIndex)}
                        >
                            {link.title}
                        </a>
                    );
                })}
            </div>
        );
    }

    private handleLinkClick = (linkIndex: number) => (e: React.MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();

        if (
            linkIndex >= 0 &&
            typeof this.props.links[linkIndex] !== 'undefined' &&
            typeof this.props.links[linkIndex].onClick !== 'undefined' &&
            this.props.links[linkIndex].onClick
        ) {
            this.props.links[linkIndex].onClick(e);
        }
    };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/components/layout/UniversalNavigationBar.tsx/UniversalNavigationBar.tsx